import {
  ModalFooter as ChakraModalFooter,
  ModalFooterProps
} from "@chakra-ui/react";
import React from "react";

export const ModalFooter = (props: ModalFooterProps) => {
  return <ChakraModalFooter {...props} />;
};
